export const joinArrayItems = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    return value.join(', ');
  }

  return value;
};
